import { Box, Typography, TextField, ButtonGroup, Divider, Button } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import useResponsive from '../../hooks/useResponsive';
import useDebounce from '../../hooks/useDebounce';
import Iconify from '../Iconify';
import '../../css/companies/companiesFiltration.css';

const CompanyFiltration = ({ filtersEmpty, companyFilters, setCompanyFilters, totalCompanies, filteredCompaniesCount, companiesFetched, selectedDisplayMode, setSelectedDisplayMode }) => {

    const isDesktop = useResponsive('up', 'lg');

    const [search, setSearch] = useState(companyFilters.debouncedSearch || '');
    const debouncedSearch = useDebounce(search, 1000);

    // Update filters when debounced search changes
    useEffect(() => {
        setCompanyFilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setCompanyFilters]);

    const handleGridMode = useCallback(() => {
        setSelectedDisplayMode('grid');
    }, [setSelectedDisplayMode]);

    const handleListMode = useCallback(() => {
        setSelectedDisplayMode('list');
    }, [setSelectedDisplayMode]);

    return (
        <Box className='companies_Filtration_counts'>
            <Box className='companies_Filtration_wrapper'>
                <Box className='companies_Filtration_container'>

                    <TextField
                        size="small"
                        value={search}
                        placeholder='Rechercher'
                        onChange={(e) => setSearch(e.target.value)}
                        variant="outlined"
                        className='companies_Filtration_search_Box'
                        InputProps={{
                            startAdornment: <Iconify icon="bx:bx-search" className='companies_Filtration_search_icon' />,
                            sx: {
                                backgroundColor: '#fff',
                                height: '36px',
                                fontFamily: 'Mulish',
                                color: '#201E1E',
                                fontSize: '14px',
                                fontWeight: 400,
                            },
                        }}
                    />

                    {isDesktop && <Divider orientation="vertical" variant="middle" flexItem />}

                    <ButtonGroup variant="outlined">
                        <Button
                            className={selectedDisplayMode === 'grid' ? 'companies_Filtration_options_selected_button' : 'companies_Filtration_options_button'}
                            onClick={handleGridMode}
                        >
                            <Iconify icon="gg:menu-grid-r" />
                        </Button>
                        <Button
                            className={selectedDisplayMode === 'list' ? 'companies_Filtration_options_selected_button' : 'companies_Filtration_options_button'}
                            onClick={handleListMode}
                        >
                            <Iconify icon="ph:list" />
                        </Button>
                    </ButtonGroup>
                </Box>

            </Box>

            <Typography className='companies_Filtration_total_number'>
                {companiesFetched} affichés
                {!filtersEmpty && ` / ${filteredCompaniesCount} filtrés`}
                {` / ${totalCompanies} au total`}
            </Typography>

        </Box>
    );
};

export default CompanyFiltration;